const jsonCopy = (src) => JSON.parse(JSON.stringify(src));
export default jsonCopy;
